import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 'md', className = '' }) => {
  // Convert Tailwind classes to Bootstrap equivalents
  const getBootstrapSize = (size: 'sm' | 'md' | 'lg') => {
    switch (size) {
      case 'sm':
        return { width: '32px', height: '32px' };
      case 'md':
        return { width: '48px', height: '48px' };
      case 'lg':
        return { width: '64px', height: '64px' };
      default:
        return { width: '48px', height: '48px' };
    }
  };

  const logoSize = getBootstrapSize(size);

  return (
    <div 
      className={className}
      style={{
        ...logoSize,
        background: 'linear-gradient(135deg, #ff0000 0%, #ff8000 12.5%, #ffff00 25%, #00ff00 37.5%, #00ffff 50%, #0080ff 62.5%, #8000ff 75%, #ff0080 87.5%, #ff0000 100%)',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
        border: '2px solid rgba(255,255,255,0.3)'
      }}
    >
      {/* Infinity symbol shape using CSS */}
      <div
        style={{
          width: '60%',
          height: '60%',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {/* Left loop */}
        <div
          style={{
            width: '40%',
            height: '60%',
            border: '3px solid white',
            borderRight: 'none',
            borderTopRightRadius: '0',
            borderBottomRightRadius: '0',
            borderTopLeftRadius: '50%',
            borderBottomLeftRadius: '50%',
            position: 'absolute',
            left: '0',
            top: '20%'
          }}
        />
        
        {/* Right loop */}
        <div
          style={{
            width: '40%',
            height: '60%',
            border: '3px solid white',
            borderLeft: 'none',
            borderTopLeftRadius: '0',
            borderBottomLeftRadius: '0',
            borderTopRightRadius: '50%',
            borderBottomRightRadius: '50%',
            position: 'absolute',
            right: '0',
            top: '20%'
          }}
        />
        
        {/* Black diagonal line in left loop */}
        <div
          style={{
            width: '2px',
            height: '30%',
            background: 'black',
            position: 'absolute',
            left: '25%',
            top: '35%',
            transform: 'rotate(45deg)',
            borderRadius: '1px'
          }}
        />
      </div>
    </div>
  );
};

export default Logo;
